import {Catalog} from "./Catalog";

export const CatalogWrapper = () => (
    <>
        <Catalog/>
    </>
);